import SideBar from "../../components/sidebar/sidebar";
import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";


const ProcessingTeam = () => {
  const { t } = useTranslation(["home"]);
  return (
    <div className="flex mt-16">
      <SideBar title={t("Dashboard")} />
      <main className="w-full overflow-hidden">
        <Outlet />
      </main>
    </div>
  );
};
export default ProcessingTeam;
